import type { ComponentType } from 'react';

let loadedPage: ComponentType | null = null;
let pendingPage: Promise<ComponentType> | null = null;

/** Loads the workspace chunk once, so "Open analysis" can render the page synchronously in its view transition. */
export const preloadAnalysisWorkspace = (): Promise<ComponentType> => {
	pendingPage ??= import('./AnalysisWorkspacePage')
		.then((module) => {
			loadedPage = module.AnalysisWorkspacePage;
			return module.AnalysisWorkspacePage;
		})
		.catch((error: unknown) => {
			// Let the next call (or the route's lazy load) retry.
			pendingPage = null;
			throw error;
		});
	return pendingPage;
};

/** The page component once `preloadAnalysisWorkspace` has resolved, else null. */
export const getPreloadedAnalysisWorkspace = (): ComponentType | null => loadedPage;
